import { useTakeoverExperimentContext } from 'modules/experiments/contexts';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { WinningCriteriaTestDurationSettings } from './WinningCriteriaTestDurationSettings';
import { StyledSettingsFieldValue, StyledSettingsFormField } from './Styled';

export const BlastSettings = () => {
  const { t } = useExperimentsTranslations();
  const {
    holdoutMetaInfo: { attributionPeriodHours, hasHoldOutGroup },
  } = useTakeoverExperimentContext();

  return (
    <>
      {hasHoldOutGroup && (
        <StyledSettingsFormField
          labelText={t('settings.holdoutSettings.attributionWindow')}
          isHorizontalLayout
        >
          <StyledSettingsFieldValue>{attributionPeriodHours}</StyledSettingsFieldValue>
        </StyledSettingsFormField>
      )}
      <WinningCriteriaTestDurationSettings />
    </>
  );
};
